"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileMapper = void 0;
const mapper_1 = require("./mapper");
const reputationVote_1 = require("./reputationVote");
class ProfileMapper {
    static mapProfile(data) {
        const profile = mapper_1.PdaMapper.map(data, this.UserProfileSchema);
        profile.signature = profile.title;
        return profile;
    }
    static mapMentions(data, showPosts = false) {
        const rawList = Array.isArray(data[0]) ? data[0] : [];
        const total = typeof data[1] === 'number' ? data[1] : rawList.length;
        const mentions = rawList.map((item) => this.mapMention(item, showPosts));
        return { mentions, total };
    }
    static mapAttachment(raw) {
        const isImage = typeof raw[1] === 'number' && raw[1] > 0;
        if (isImage) {
            return {
                id: raw[0],
                isImage: true,
                name: raw[2],
                size: raw[3],
                url: raw[4],
                width: raw[5],
                height: raw[6],
            };
        }
        return {
            id: raw[0],
            isImage: false,
            name: typeof raw[2] === 'string' ? raw[2] : `file-${raw[0]}`,
            size: raw[3],
            url: typeof raw[2] === 'string' ? raw[2] : undefined,
        };
    }
    static mapMention(raw, _showPosts) {
        const mention = mapper_1.PdaMapper.map(raw, this.MentionSchema);
        if (typeof raw[14] === 'string') {
            mention.postContent = raw[14];
        }
        if (typeof raw[16] === 'string' && raw[16].trim()) {
            mention.signature = raw[16];
        }
        if (Array.isArray(raw[17]) && raw[17].length > 0) {
            mention.attachments = raw[17]
                .filter((item) => Array.isArray(item))
                .map((item) => this.mapAttachment(item));
        }
        return mention;
    }
    static mapUserSearch(data) {
        // Data: [count, [users]]
        // User item: [id, name, group, avatar]
        const items = (data[1] || []);
        return items.map(u => ({
            id: u[0],
            name: u[1],
            groupId: u[2],
            avatar: u[3]
        }));
    }
    static mapReputationHistory(data) {
        // Data: [totalCount, [items]]
        return {
            totalCount: data[0],
            items: mapper_1.PdaMapper.mapList(data[1], this.ReputationItemSchema),
        };
    }
    static mapHistory(data) {
        // Response wrapper: [reqId, status, totalCount, [[items]]]
        // Transport return: [totalCount, [[items]]]
        return {
            count: data[0],
            topics: mapper_1.PdaMapper.mapList(data[1], this.HistoryTopicSchema)
        };
    }
}
exports.ProfileMapper = ProfileMapper;
ProfileMapper.DeviceSchema = {
    id: 0,
    name: 1,
    type: 2
};
ProfileMapper.CuratedTopicSchema = {
    id: 0,
    title: 1
};
ProfileMapper.WarnLogSchema = {
    date: { index: 0, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    type: 1, // 0: Note, 1: +20, 2: -20
    moderatorId: 2,
    moderatorName: 3,
    reason: 4,
    postId: 5,
    value: 6,
};
ProfileMapper.RewardSchema = {
    imageUrl: 0,
    title: 1,
    description: 2,
    count: 3,
    date: { index: 4, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    url: 5
};
ProfileMapper.UserProfileSchema = {
    id: 0,
    name: { index: 1, map: (v) => mapper_1.PdaMapper.cleanString(v) },
    avatar: 2,
    groupId: 3,
    status: { index: 4, map: (v) => mapper_1.PdaMapper.cleanString(v) },
    title: { index: 5, map: (v) => mapper_1.PdaMapper.cleanString(v) },
    aboutMe: { index: 6, map: (v) => mapper_1.PdaMapper.cleanString(v) },
    regDate: { index: 7, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    lastVisit: { index: 8, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    birthday: { index: 9, map: (v) => (typeof v === 'string' ? v : '') },
    gender: 10,
    warnLevel: 26,
    location: { index: 12, map: (v) => mapper_1.PdaMapper.cleanString(v) },
    devices: { index: 13, list: ProfileMapper.DeviceSchema },
    siteKarma: { index: 14, map: (v) => (v || 0) / 100 },
    sitePosts: 15,
    siteComments: 16,
    forumReputation: 17,
    forumTopics: 18,
    forumPosts: 19,
    curatedTopics: { index: 21, list: ProfileMapper.CuratedTopicSchema },
    history: { index: 22, list: ProfileMapper.WarnLogSchema },
    email: 23,
    registrationIp: 24,
    lastIp: 25,
    extraId: 10,
    rewards: { index: 30, list: ProfileMapper.RewardSchema },
    aliases: 31
};
ProfileMapper.MentionSchema = {
    contentType: 0,
    isSeen: { index: 1, map: (v) => v !== 0 },
    forumId: 2,
    forumTitle: 3,
    topicId: 4,
    topicTitle: 5,
    postId: 6,
    postNumber: 7,
    userId: 8,
    userName: 9,
    userGroup: 10,
    lastVisit: { index: 11, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    reputation: 12,
    date: { index: 13, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    avatar: 15,
    flags: 18,
};
ProfileMapper.HistoryTopicSchema = {
    id: 0,
    title: 1,
    subtitle: 2,
    bitmask: 3,
    replies: 4,
    lastPostTs: { index: 5, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    lastUserId: 6,
    lastUserName: 7,
    visitTs: { index: 8, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) }
};
ProfileMapper.ReputationItemSchema = {
    voteId: 0,
    timestamp: { index: 1, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    fromId: 2,
    toId: 3,
    fromName: { index: 4, map: (v) => mapper_1.PdaMapper.cleanString(v) },
    toName: { index: 5, map: (v) => mapper_1.PdaMapper.cleanString(v) },
    value: 6,
    isDown: { index: 6, map: (v) => (0, reputationVote_1.decodeReputationVoteValue)(v).isDown },
    isDenied: { index: 6, map: (v) => (0, reputationVote_1.decodeReputationVoteValue)(v).isDenied },
    topicId: 7,
    topicTitle: { index: 8, map: (v) => mapper_1.PdaMapper.cleanString(v) },
    postId: 9,
    commentId: {
        index: 9,
        map: (v) => (typeof v === 'number' && v < 0 ? -v : undefined),
    },
    source: {
        index: [7, 9],
        map: (v) => (0, reputationVote_1.decodeReputationVoteSource)(v[0], v[1]),
    },
    reason: { index: 10, map: (v) => mapper_1.PdaMapper.cleanString(v) },
    modified: {
        index: [11, 12, 13],
        map: (v) => (0, reputationVote_1.mapReputationVoteModified)(v),
    },
};
